import React from "react";
import { ShieldCheckIcon, ZapIcon, InfinityIcon, CreditCardIcon, ArrowDownIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { OfferCountdown } from "../OfferCountdown";
import { MOCKUP_URL } from "../../data/checkout";
const contents = [{
  value: "6",
  label: "Specialized volumes"
}, {
  value: "5",
  label: "Professional bonuses"
}, {
  value: "+",
  label: "Checklists & worksheets"
}];
const trust = [{
  icon: ZapIcon,
  label: "Immediate Digital Access"
}, {
  icon: CreditCardIcon,
  label: "One-Time Payment of $27 USD"
}, {
  icon: InfinityIcon,
  label: "Lifetime Access"
}];
export function HeroSection() {
  return <header className="w-full bg-cream" data-id="element-250" data-mp="1ihsadhyqytay">
      <div className="bg-wine px-4 py-2.5 text-center text-[13px] font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-251" data-mp="1dljm9f2knprn">
        Special launch offer · Complete collection for only $27 USD
      </div>

      <div className="mx-auto grid max-w-6xl gap-10 px-5 pb-16 pt-8 sm:pt-12 lg:grid-cols-[1.05fr_1fr] lg:items-start lg:gap-14" data-id="element-252" data-mp="14jtwedoc8yvz">
        <div data-id="element-253" data-mp="31mku5cr9bssw">
          <p className="text-center font-serif text-xl font-black text-wine sm:text-2xl lg:text-left" data-id="element-254" data-mp="31m1fq60tfmjm">
            Interceptive Orthodontics Blueprint™
          </p>
          <p className="mt-1 text-center text-sm font-semibold uppercase tracking-widest text-muted lg:text-left" data-id="element-255" data-mp="2sor2if4ftnc2">
            By Dr. Valeria Montes
          </p>

          <h1 className="mt-6 text-center font-serif text-[32px] font-black leading-[1.12] text-navy sm:text-5xl lg:text-left lg:text-[52px]" data-id="element-256" data-mp="3kevlqaggo4bp">
            Know When to Intervene, When to Monitor, and How to Plan Early Orthodontic Treatment
            <span className="mt-3 block text-wine" data-id="element-257" data-mp="3bd5vv9289dg1">— With a Clear 6-Step Clinical Framework.</span>
          </h1>

          <img src={MOCKUP_URL} alt="Interceptive Orthodontics Blueprint collection: 6 volumes and 5 bonuses" className="mx-auto mt-8 w-full max-w-md lg:hidden" data-id="element-258" data-mp="3gb7c7m89qynt" />

          <p className="mt-8 text-center text-lg font-bold text-navy sm:text-xl lg:text-left" data-id="element-259" data-mp="24vsgsmvpkeut">
            Stop approaching every growing patient as a new planning challenge.
          </p>
          <p className="mt-3 text-center text-base leading-relaxed text-muted sm:text-lg lg:text-left" data-id="element-260" data-mp="5jbyj5l6vkz5">
            Discover a structured, visual educational system designed to help you evaluate developing
            malocclusions, interpret mixed dentition findings, organize Phase I treatment decisions, and
            create clearer clinical plans.
          </p>

          <div className="mt-6 grid grid-cols-3 gap-2 sm:gap-3" data-id="element-261" data-mp="3iwf0yq3papza">
            {contents.map(c => <div key={c.label} className="rounded-xl bg-white px-2 py-3 text-center shadow-sm ring-1 ring-navy/10" data-id="element-262" data-mp="3dzez6rdvw9dz">
                <p className="font-serif text-3xl font-black text-wine" data-id="element-263" data-mp="39ycxm3whvl8u">{c.value}</p>
                <p className="mt-0.5 text-xs font-semibold leading-tight text-navy sm:text-sm" data-id="element-264" data-mp="1c5pf1wxjm58k">{c.label}</p>
              </div>)}
          </div>

          <div className="mt-6 overflow-hidden rounded-2xl ring-1 ring-navy/10" data-id="element-265" data-mp="2q3a5nqaibvr3">
            <p className="bg-white px-5 py-4 text-center text-[15px] italic text-muted sm:text-base" data-id="element-266" data-mp="2q17gt9l3c8ny">
              From “Does this child need orthodontic intervention now?”
            </p>
            <div className="flex justify-center bg-white pb-1" data-id="element-267" data-mp="2zuy1s4i0e0yw">
              <ArrowDownIcon className="h-5 w-5 text-wine" aria-hidden="true" data-id="element-268" data-mp="33t59k9uhvrxy" />
            </div>
            <p className="bg-navy px-5 py-4 text-center text-[15px] font-semibold text-white sm:text-base" data-id="element-269" data-mp="275hf7nh2leal">
              To “I know what to evaluate, which factors matter, and how to organize the next decision.”
            </p>
          </div>
        </div>

        <div className="lg:sticky lg:top-6" data-id="element-270" data-mp="2l3xh913zmgme">
          <img src={MOCKUP_URL} alt="Interceptive Orthodontics Blueprint collection: 6 volumes and 5 bonuses" className="mx-auto hidden w-full max-w-lg lg:block" data-id="element-271" data-mp="2l4qi5lg9mbwm" />

          <div className="rounded-3xl bg-white p-5 shadow-[0_20px_50px_-20px_rgba(19,35,63,0.35)] ring-1 ring-navy/10 sm:p-7 lg:-mt-4" data-id="element-272" data-mp="c5a1xensplt">
            <p className="mx-auto w-fit rounded-full bg-wine px-4 py-1.5 text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-273" data-mp="3q2u79qqprepe">
              Special launch offer
            </p>
            <p className="mt-4 text-center text-sm font-bold uppercase tracking-wide text-muted" data-id="element-274" data-mp="7uwc9yyyspo6">
              Your introductory price
            </p>
            <p className="text-center font-serif text-6xl font-black text-navy" data-id="element-275" data-mp="hudgsd2hcxik">
              $27 <span className="text-2xl font-bold" data-id="element-276" data-mp="cx3uv7eav3zh">USD</span>
            </p>

            <div className="mt-5" data-id="element-277" data-mp="rkynknsb58ck">
              <CtaButton id="hero-cta" label="Get the Interceptive Orthodontics Blueprint™" data-id="element-278" data-mp="rk6r7aqvz6l8" />
            </div>

            <OfferCountdown data-id="element-279" data-mp="mmndqd20ixuc" />

            <p className="mt-4 text-center text-xs text-muted" data-id="element-280" data-mp="mohoiyjkl9kp">
              Limited-time pricing is available only while the promotional offer remains active.
            </p>

            <ul className="mt-5 space-y-2 border-t border-navy/10 pt-5" data-id="element-281" data-mp="vomvj7kuq5yc">
              {trust.map(t => <li key={t.label} className="flex items-center gap-2.5 text-sm font-semibold text-navy" data-id="element-282" data-mp="1f6iqjty7yhik">
                  <t.icon className="h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-283" data-mp="1k5lufb2gqhoy" />
                  {t.label}
                </li>)}
              <li className="flex items-center gap-2.5 text-sm font-semibold text-navy" data-id="element-284" data-mp="1a8qxuxpr2rdb">
                <ShieldCheckIcon className="h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-285" data-mp="whu9xk6rqycl" />
                7-Day Money-Back Guarantee
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>;
}